import { gql } from '@apollo/client'

const EDIT_LEAD_STAGE = gql`
  mutation EDIT_LEAD_STAGE(
    $leadStage: ID!
    $name: String!
    $color: String!
    $users: [ID!]!
    $requireReject: Boolean
    $dueDays: Int
  ) {
    editLeadStage(
      leadStage: $leadStage
      name: $name
      color: $color
      users: $users
      requireReject: $requireReject
      dueDays: $dueDays
    ) {
      id
      name
      color
      requireReject
      dueDays
      users {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default EDIT_LEAD_STAGE
